var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useState } from "react";
var useModalsCtxProvider = function () {
    var _a = useState([]), modals = _a[0], setModals = _a[1];
    var openModal = function (id, title, modal, preventClose) {
        if (preventClose === void 0) { preventClose = false; }
        setModals(function (modals) { return __spreadArray(__spreadArray([], modals), [
            { id: id, title: title, content: modal, preventClose: preventClose },
        ]); });
    };
    var closeModal = function (id) {
        setModals(function (modals) { return modals.filter(function (m) { return m.id !== id; }); });
    };
    return { modals: modals, openModal: openModal, closeModal: closeModal };
};
export default useModalsCtxProvider;
//# sourceMappingURL=useModalsCtxProvider.js.map